import { useDispatch } from 'react-redux';
import http from 'hub-http/clients/apiClient';
import PostPublishDomainSetupMessageModal from './PostPublishDomainSetupMessageModal';
import * as actionTypes from 'ContentEditorUI/redux/actions/actionTypes';
import { useEffect } from 'react';
import TranslationCreatedSuccessMessage from './TranslationCreatedSuccessMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CmsSettingsModals = ({
  contentUrl,
  isStaging = false
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: actionTypes.FETCH_CMS_SETTINGS_STARTED
    });
    http.get('cms-user-settings').then(settingsResponse => {
      dispatch({
        type: actionTypes.FETCH_CMS_SETTINGS_SUCCESS,
        payload: settingsResponse
      });
    }).catch(() => {
      dispatch({
        type: actionTypes.FETCH_CMS_SETTINGS_FAILURE
      });
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PostPublishDomainSetupMessageModal, {
      publishedContentUrl: contentUrl,
      isStaging: isStaging
    }), /*#__PURE__*/_jsx(TranslationCreatedSuccessMessage, {})]
  });
};
export default CmsSettingsModals;